
































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import BaseVue from '@/mixins/BaseVue'
import {
  SelectedCMMF,
  SalesOrg,
  EPromotionType,
  EPromotionStatus,
  PromotionInput,
  UpdatePossibleDp,
  EBUStatus,
  UpdatePossibleSnp,
  StatusChangeUpdate
} from '@/services/connecteur'
import ActionComponent from './ActionComponent.vue'
import CMMFManagement from './CMMFManagement.vue'
import DateRangePicker from '@/components/shared/DateRangePicker.vue'
import StarsPicker from '@/components/shared/StarsPicker.vue'
import VTextFieldWithValidation from '@/components/Inputs/VTextFieldWithValidation.vue'
import VSelectWithValidation from '@/components/Inputs/VSelectWithValidation.vue'
import VTextAreaWithValidation from '@/components/Inputs/VTextAreaWithValidation.vue'
import VAutocompleteWithValidation from '@/components/Inputs/VAutocompleteWithValidation.vue'
import VComboboxWithValidation from '@/components/Inputs/VComboboxWithValidation.vue'
import ActionDialog from '@/components/Dialogs/ActionDialog.vue'
import { dateShortFormat } from '@/filters/dateFormat'
import moment from 'moment'
import { DataRetourActionComponent } from '@/models/utils'
import { EnumDictionary } from '../../models/Enum'
import DatePicker from '@/components/shared/DatePicker.vue'
import promotionModule from '@/store/modules/PromotionModule'
import HeaderPromotion from '@/components/Promotions/HeaderPromotion.vue'
import ContactView from '@/components/Promotions/ContactView.vue'
import CustomerSelect from '@/components/Selects/CustomerSelect.vue'
import SetStatusParameter from '@/models/SetStatusParameter'
import userModule from '@/store/modules/UserModule'
import serviceModule from '@/store/modules/ServiceModule'
import SalesOrgsModule from '@/store/modules/SalesOrgsModule'

export enum EPromotionMechanism {
  LESS_THAN_5_PERCENT = 0,
  LESS_THAN_10_PERCENT = 1,
  LESS_THAN_15_PERCENT = 2,
  LESS_THAN_20_PERCENT = 3,
  MORE_THAN_20_PERCENT = 4,
  LOYALTY_PROGRAM = 5,
  IMMEDIATE = 6,
}

@Component({
  components: {
    CMMFManagement,
    DateRangePicker,
    VTextFieldWithValidation,
    VSelectWithValidation,
    VTextAreaWithValidation,
    ActionComponent,
    VAutocompleteWithValidation,
    DatePicker,
    ActionDialog,
    HeaderPromotion,
    ContactView,
    CustomerSelect,
    StarsPicker,
    VComboboxWithValidation
  },
  filters: {
    dateShortFormat
  },
  beforeRouteLeave (to: Route, from: Route, next: any) {
    // @ts-ignore
    this.releaseLock(next)
  }
})
export default class PromotionDisplay extends Mixins(BaseVue) {
  public data () {
    return {
      promotionActuelle: new PromotionInput({
        promotionName: '',
        listOfSelectedCMMF: [],
        customerId: 0,
        salesOrgId: 0,
        statusId: EPromotionStatus.NEW,
        isQuotationEnabled: true,
        isOnlineShop: false,
        isFixedSlot: false
      }) as PromotionInput,
      promotionMechanism: null as string | null | { value: string, label: string }
    }
  }

  public loading = true
  public sellInWindow: string[] = []
  public get salesOrgs(): SalesOrg[] {
    return SalesOrgsModule.salesOrgsWithoutDisabled
  }

  public currentIdSelected = this.$route.params.id
  public EPromotionStatus = EPromotionStatus
  public lockObtained: boolean | null = this.isCreation || null
  public isOnDemandPlannerList = false
  public showShortTermDialog = false
  public kamOrDpError = false
  public snpCmmfs = new Array<string>()
  public setStatusCallParameters: SetStatusParameter =
    new SetStatusParameter()

  public KAM_STATUSES = [
    EPromotionStatus.NEW,
    EPromotionStatus.REWORK,
    EPromotionStatus.PREVALIDATED
  ]

  public DP_STATUSES = [
    EPromotionStatus.DRAFT,
    EPromotionStatus.CHANGED,
    EPromotionStatus.APPROVED,
    EPromotionStatus.CANCELLED
  ]

  public TYPE_MECHANISMS: EnumDictionary<
    EPromotionType,
    Array<EPromotionMechanism>
  > = {
      [EPromotionType.PRICE_REDUCTION]: [
        EPromotionMechanism.LESS_THAN_5_PERCENT,
        EPromotionMechanism.LESS_THAN_10_PERCENT,
        EPromotionMechanism.LESS_THAN_15_PERCENT,
        EPromotionMechanism.LESS_THAN_20_PERCENT,
        EPromotionMechanism.MORE_THAN_20_PERCENT
      ],
      [EPromotionType.REBATES]: [
        EPromotionMechanism.LOYALTY_PROGRAM,
        EPromotionMechanism.IMMEDIATE
      ],
      [EPromotionType.SLOB_EXHAUSTION]: [],
      [EPromotionType.PURE_PLAYER]: []
    }

  public now: Date = new Date();
  public pendingRequestLocalStorageKey = 'Request_Pending_';
  public pendingRequestTimeOut = 300;
  public isThereAnApprovalPendingRequest = false;
  public statusNameSave: string | undefined

  public created () {
    setInterval(() => {
      this.now = new Date()
    }, 1000)
  }

  public async obtainLock () {
    if (this.$data.promotionActuelle != null) {
      try {
        this.lockObtained = await serviceModule.promotionApi.obtainLock(
          this.$data.promotionActuelle.id
        )
        if (this.lockObtained) {
          window.addEventListener('beforeunload', this.releaseLock)
          window.addEventListener('unload', this.releaseLock)
        }
      } catch (error) {
        this.lockObtained = false
        this.displayError(error)
      }
    }
  }

  public async releaseLock (next: any) {
    if (this.lockObtained) {
      await serviceModule.promotionApi.releaseLock(
        this.$data.promotionActuelle.id,
        false
      )
      window.removeEventListener('beforeunload', this.releaseLock)
      window.removeEventListener('unload', this.releaseLock)
    }
    if (next != null) {
      next()
    }
  }

  public async forceLockRelease () {
    try {
      await serviceModule.promotionApi.releaseLock(
        this.$data.promotionActuelle.id,
        true
      )
      this.loadPromotion()
    } catch (error) {
      this.displayError(error)
    }
  }

  public get minDeadLineDate (): string {
    return moment().toISOString()
  }

  public get canEditDeadLine (): boolean {
    return (
      (userModule.userIsDemandPlanner || userModule.userIsAdmin) &&
      (this.$data.promotionActuelle.statusId === EPromotionStatus.DRAFT ||
        this.$data.promotionActuelle.statusId === EPromotionStatus.CHANGED)
    )
  }

  public get disableIsFixedSlot (): boolean {
    return this.isNotNewOrRework || this.$data.promotionActuelle.salesOrgId !== 10
  }

  @Watch('now')
  public SetSubmitBtnLoadingIfApprovalIsPending () {
    if (this.$data.promotionActuelle.id) {
      const pendingRequestLocalStorageKey = this.pendingRequestLocalStorageKey + this.$data.promotionActuelle.id.toString()
      const itemLocalStorage = localStorage.getItem(pendingRequestLocalStorageKey) ?? null
      if (itemLocalStorage !== null) {
        const time = new Date(itemLocalStorage)
        const diff = Math.abs(time.getTime() - this.now.getTime())
        const elapsedSeconds = Math.floor(diff / 1000)
        if (elapsedSeconds < this.pendingRequestTimeOut && this.isThereAnApprovalPendingRequest !== true) {
          this.isThereAnApprovalPendingRequest = true
        } else if (elapsedSeconds > this.pendingRequestTimeOut) {
          this.isThereAnApprovalPendingRequest = false
          this.RemoveLogRequestPending(this.$data.promotionActuelle.id.toString())
          window.location.reload()
        }
      } else {
        this.isThereAnApprovalPendingRequest = false
      }
    }
  }

  @Watch('isThereAnApprovalPendingRequest', { immediate: true })
  public lockApprovalBtn () {
    this.loading = this.isThereAnApprovalPendingRequest
    if (this.isThereAnApprovalPendingRequest === true) {
      if (!this.statusNameSave) {
        this.statusNameSave = this.$data.promotionActuelle.statusName
      }
      this.$data.promotionActuelle.statusName = 'On going attempt of SAP quotation creation...'
    } else if (this.statusNameSave) {
      this.$data.promotionActuelle.statusName = this.statusNameSave
    }
  }

  public logRequestPending (promotionId: string) {
    const pendingRequestLocalStorageKey = this.pendingRequestLocalStorageKey + promotionId
    localStorage.setItem(pendingRequestLocalStorageKey, new Date().toISOString())
  }

  public RemoveLogRequestPending (promotionId: string) {
    const pendingRequestLocalStorageKey = this.pendingRequestLocalStorageKey + promotionId
    localStorage.removeItem(pendingRequestLocalStorageKey)
  }

  public get isAdmin (): boolean {
    return userModule.isUserAdminOnSalesOrg(
      this.$data.promotionActuelle?.salesOrgId
    )
  }

  public async loadPromotion () {
    this.$data.promotionActuelle = await serviceModule.promotionApi.getById(
      +this.$route.params.id
    )
    if (EPromotionMechanism[this.$data.promotionActuelle.mechanism] !== undefined && this.$data.promotionActuelle.type === 0) {
      this.$data.promotionMechanism = { value: this.$data.promotionActuelle.mechanism, label: this.$t(`promotionMechanism.${this.$data.promotionActuelle.mechanism}`).toString() }
    } else {
      this.$data.promotionMechanism = this.$data.promotionActuelle.mechanism
    }

    this.isOnDemandPlannerList =
      this.$data.promotionActuelle.demandPlannerListId?.includes(
        userModule.id as number
      ) === true
    if (
      userModule.userIsSNP &&
      this.$data.promotionActuelle.statusId === EPromotionStatus.BU_CHECK &&
      !this.snpCmmfs.length
    ) {
      if (this.$data.promotionActuelle.listOfSelectedCMMF) {
        const listOfSelectedCmmfCode = (this.$data.promotionActuelle as PromotionInput).listOfSelectedCMMF?.map(cmmf => cmmf.code || '')
        this.snpCmmfs = await serviceModule.snpMappingApi.getCmmfs(listOfSelectedCmmfCode)
      }
    }
    if (this.canObtainLock) {
      this.obtainLock()
    }
  }

  public async fetchDatas () {
    try {
      if (!this.isCreation && !isNaN(+this.$route.params.id)) {
        await this.loadPromotion()
      } else if (this.salesOrgs.length === 1) {
        this.$data.promotionActuelle.salesOrgId = this.salesOrgs[0].id
          ? this.salesOrgs[0].id
          : 0
      }
    } catch (error) {
      this.displayError(error)
    }
  }

  public get canEdit (): boolean {
    return this.isOnStatus(this.KAM_STATUSES, this.DP_STATUSES)
  }

  public get canObtainLock () {
    // L'utilisateur peut effectuer certaines actions même s'il ne peut pas modifier la promotion.
    return (
      this.canEdit ||
      this.isOnStatus(
        [EPromotionStatus.APPROVED, EPromotionStatus.BU_CHECK],
        []
      )
    )
  }

  public isOnStatus (
    kamStatuses: EPromotionStatus[],
    dpStatuses: EPromotionStatus[]
  ): boolean {
    // Les admins ont le droit de se substituer à l'utilisateur devant modifier une promotion.
    if (this.isAdmin) {
      return true
    }
    // KAM
    if (
      this.$data.promotionActuelle.statusId &&
      kamStatuses.includes(this.$data.promotionActuelle.statusId)
    ) {
      return (
        this.$data.promotionActuelle.kamId === userModule.id ||
        this.$data.promotionActuelle.assistantKAMListId?.includes(userModule.id as number) ||
        this.$data.promotionActuelle.statusId === EPromotionStatus.NEW
      )
    }
    // DP
    if (
      this.$data.promotionActuelle.statusId &&
      dpStatuses.includes(this.$data.promotionActuelle.statusId) &&
      this.$data.promotionActuelle.demandPlannerListId &&
      userModule.id
    ) {
      return this.isOnDemandPlannerList
    }
    // SNP
    if (this.$data.promotionActuelle.statusId === EPromotionStatus.BU_CHECK) {
      return this.snpCmmfs.length > 0
    }
    return false
  }

  public get isEditing (): boolean {
    return this.lockObtained === true && this.canEdit
  }

  public async savePromotion (): Promise<boolean> {
    let res = false
    this.editPromotionMechanism()

    try {
      if (this.isCreation) {
        const response = await serviceModule.promotionApi.postPromotion(
          this.$data.promotionActuelle
        )
        this.displayMessage(this.$t('promotions.added'))

        res = true
        if (response !== 0) {
          await this.$router.push(`/promotion/${response}`)
          await this.loadPromotion()
        }
      } else {
        const response = await serviceModule.promotionApi.putPromotion(
          this.$data.promotionActuelle
        )
        if (response) {
          await this.loadPromotion()
          this.displayMessage(this.$t('promotions.updated'))
          res = true
        }
      }

      promotionModule.fetchWorkList()
    } catch (error) {
      if (error.response && error.response.errors) {
        let errorToDisplay = this.$t('promotion.updateError')
        errorToDisplay += Object.keys(error.response.errors).reduce((errorToDisplayAcc, errorsKey) => {
          errorToDisplayAcc += '<br/>'
          errorToDisplayAcc += errorsKey + ': ' + error.response.errors[errorsKey].join(', ')
          return errorToDisplayAcc
        }, '')
        this.displayError(errorToDisplay)
      } else {
        this.displayError(error)
      }
      res = false
    }
    return res
  }

  public updateListeCMMFSelect (listeCMMFSelect: SelectedCMMF[] = []) {
    this.$data.promotionActuelle.listOfSelectedCMMF = listeCMMFSelect
  }

  public get promotionType () {
    const result = []
    for (const item in EPromotionType) {
      if (!isNaN(Number(item))) {
        result.push({
          value: +item,
          label: this.$t(`promotionType.${EPromotionType[item]}`)
        })
      }
    }
    return result
  }

  public get promotionMechanisms () {
    // Récupération des mécanismes disponibles.
    let mechanisms: Array<EPromotionMechanism> = []
    if (
      this.$data.promotionActuelle.type !== undefined &&
      this.TYPE_MECHANISMS[(this.$data.promotionActuelle as PromotionInput).type!]
    ) {
      mechanisms = this.TYPE_MECHANISMS[(this.$data.promotionActuelle as PromotionInput).type!]
    }
    if (
      !this.$data.promotionActuelle.mechanism ||
      mechanisms.indexOf(this.$data.promotionActuelle.mechanism) === -1
    ) {
      this.$data.promotionActuelle.mechanism = undefined
    }

    // Retourne la liste.
    return mechanisms.map(item => {
      return {
        value: EPromotionMechanism[item],
        label: this.$t(`promotionMechanism.${EPromotionMechanism[item]}`)
      }
    })
  }

  public async onSubmit (): Promise<boolean> {
    let promotionHaveBeenUpdated = false
    // @ts-ignore
    const success = await this.$refs.form.validate()
    if (!success) {
      this.displayError(this.$t('promotions.incomplete'))

      return promotionHaveBeenUpdated
    }

    this.loading = true
    await this.savePromotion().then(reponse => {
      this.$nextTick(() => {
        if (this.$refs.form) {
          // @ts-ignore
          this.$refs.form.reset()
        }
      })

      promotionHaveBeenUpdated = reponse
    })

    this.loading = false
    return promotionHaveBeenUpdated
  }

  public async submitDpUpdate (): Promise<boolean> {
    let promotionHaveBeenUpdated = false
    try {
      // @ts-ignore
      const success = await this.$refs.form.validate()

      if (success) {
        this.loading = true
        const update = new UpdatePossibleDp({
          id: this.$data.promotionActuelle.id,
          criticity: this.$data.promotionActuelle.criticity,
          dpComment: this.$data.promotionActuelle.dpComment,
          listOfSelectedCMMF: this.$data.promotionActuelle.listOfSelectedCMMF,
          kamId: this.$data.promotionActuelle.kamId,
          dpIds: this.$data.promotionActuelle.demandPlannerListId,
          assistantKAMId: this.$data.promotionActuelle.assistantKAMListId,
          isQuotationEnabled: this.$data.promotionActuelle.isQuotationEnabled,
          supplyDeadline: this.$data.promotionActuelle.supplyDeadline
        })
        await serviceModule.promotionApi.updatePromotionDp(update)
        await this.loadPromotion()
        this.displayMessage(this.$t('promotion.saved').toString())
        promotionHaveBeenUpdated = true
      } else {
        this.displayError(this.$t('promotions.incomplete'))
      }
    } catch (error) {
      this.displayError(error)
      promotionHaveBeenUpdated = false
    }
    this.loading = false
    return promotionHaveBeenUpdated
  }

  public async submitSnpUpdate (): Promise<boolean> {
    let promotionHaveBeenUpdated = false
    try {
      // @ts-ignore
      const success = await this.$refs.form.validate()

      if (success) {
        this.loading = true
        const update = new UpdatePossibleSnp({
          id: this.$data.promotionActuelle.id,
          listOfSelectedCMMF: this.$data.promotionActuelle.listOfSelectedCMMF
        })
        await serviceModule.promotionApi.updatePromotionSnp(update)
        this.displayMessage(this.$t('promotion.saved').toString())
        await this.loadPromotion()
        promotionHaveBeenUpdated = true
      } else {
        this.displayError(this.$t('promotions.incomplete'))
      }
    } catch (error) {
      this.displayError(error)
      promotionHaveBeenUpdated = false
    }
    this.loading = false
    return promotionHaveBeenUpdated
  }

  public isNotAlreadyCall (statusParams: SetStatusParameter
  ) {
    return (
      statusParams.promotionId !== this.setStatusCallParameters.promotionId &&
      statusParams.statusId !== this.setStatusCallParameters.statusId &&
      statusParams.reason !== this.setStatusCallParameters.reason
    )
  }

  public async sendTo (data: DataRetourActionComponent) {
    const queryParams = new SetStatusParameter({
      promotionId: this.$data.promotionActuelle.id,
      reason: data.reason,
      statusId: data.newStatus
    })
    if (this.kamOrDpError) {
      this.displayError(this.$t('promotions.incomplete'))
    } else if (this.isNotAlreadyCall(queryParams)) {
      if (queryParams.statusId === EPromotionStatus.APPROVED && this.$data.promotionActuelle.id) {
        this.logRequestPending(this.$data.promotionActuelle.id.toString())
      }

      this.setStatusCallParameters = queryParams
      try {
        this.loading = true
        const cmmfAutomaticallyAccepted = await serviceModule.promotionApi.setStatus(
          new StatusChangeUpdate({
            idPromotion: this.$data.promotionActuelle.id,
            newStatus: data.newStatus,
            cancelReasonId: data.reason
          }))

        if (cmmfAutomaticallyAccepted && cmmfAutomaticallyAccepted.length > 0) {
          this.displayMessage(this.$t('promotionCMMF.buCheck.automaticallyAccepted'))
        } else {
          this.displayMessage(this.$t('promotion.sendTo').toString())
        }

        await promotionModule.fetchWorkList()
        this.redirectToWorklist()
      } catch (err) {
        this.displayError(err)
      } finally {
        this.setStatusCallParameters = new SetStatusParameter()
        if (queryParams.statusId === EPromotionStatus.APPROVED && this.$data.promotionActuelle.id) {
          this.RemoveLogRequestPending(this.$data.promotionActuelle.id.toString())
        }
      }
      this.loading = false
    }
  }

  public redirectToWorklist () {
    this.$router.push({ name: 'home' })
  }

  public showPopupIfNecessary (data: DataRetourActionComponent) {
    const shortTermDate = moment().add(28, 'days')
    const currentDate = moment(this.$data.promotionActuelle.plannedDeliveryDate)
    if (
      data.newStatus === EPromotionStatus.DRAFT &&
      currentDate.isBefore(shortTermDate)
    ) {
      this.showShortTermDialog = true
    } else {
      this.sendToSubmitKam(data)
    }
  }

  public async sendToSubmitKam (data: DataRetourActionComponent) {
    try {
      if (await this.onSubmit()) {
        this.loading = true
        await this.sendTo(data)
      }
    } catch (error) {
      this.displayError(error)
    }
    this.loading = false
  }

  public async sendToSubmitDp (data: DataRetourActionComponent) {
    try {
      if (await this.submitDpUpdate()) {
        this.loading
        await this.sendTo(data)
      }
    } catch (error) {
      this.displayError(error)
    }
    this.loading = false
  }

  public async sendToSubmitSnp (data: DataRetourActionComponent) {
    try {
      if (await this.submitSnpUpdate()) {
        this.loading
        await this.sendTo(data)
      }
    } catch (error) {
      this.displayError(error)
    }
    this.loading = false
  }

  public get isCreation (): boolean {
    return this.$route.name === 'createPromotions'
  }

  public get minStartSellOut () {
    if (this.$data.promotionActuelle && this.$data.promotionActuelle.sellInStart) {
      return moment(this.$data.promotionActuelle.sellInStart).format('YYYY-MM-DD')
    }

    return undefined
  }

  public isStatus (
    status: EPromotionStatus | Array<EPromotionStatus>
  ): boolean {
    return Array.isArray(status)
      ? this.$data.promotionActuelle.statusId
        ? status.includes(this.$data.promotionActuelle.statusId)
        : false
      : status === this.$data.promotionActuelle.statusId
  }

  public get areAllCmmfsAccepted (): boolean {
    if (this.$data.promotionActuelle.listOfSelectedCMMF) {
      return (
        (this.$data.promotionActuelle as PromotionInput).listOfSelectedCMMF?.filter(c => !c.acceptSupply)
          .length === 0
      )
    } else {
      return false
    }
  }

  public get areCmmfsFlagged (): boolean {
    if (this.$data.promotionActuelle.listOfSelectedCMMF) {
      return (
        (this.$data.promotionActuelle as PromotionInput).listOfSelectedCMMF!.filter(c => c.flagSupply)
          .length > 0
      )
    } else {
      return false
    }
  }

  public get areCmmfsFlaggedForBuCheck (): boolean {
    if (this.$data.promotionActuelle.listOfSelectedCMMF) {
      return (
        (this.$data.promotionActuelle as PromotionInput).listOfSelectedCMMF!.filter(
          c => c.buStatus === EBUStatus.ASKED
        ).length > 0
      )
    } else {
      return false
    }
  }

  public get areCmmfFlaggedForBuCheckAllAnswered (): boolean {
    if (this.$data.promotionActuelle.listOfSelectedCMMF) {
      return (
        (this.$data.promotionActuelle as PromotionInput).listOfSelectedCMMF?.filter(
          c => c.buStatus === EBUStatus.ASKED
        ).length === 0
      )
    } else {
      return false
    }
  }

  public get isNotNewOrRework () {
    return !this.isStatus([EPromotionStatus.NEW, EPromotionStatus.REWORK])
  }

  public get isActionForApo () {
    return this.isStatus([
      EPromotionStatus.APPROVED,
      EPromotionStatus.CANCELLED
    ])
  }

  public editPromotionMechanism () {
    if (this.$data.promotionMechanism && typeof this.$data.promotionMechanism === 'string' && this.$data.promotionActuelle.type === 0) {
      this.$data.promotionActuelle.mechanism = this.$data.promotionMechanism.includes('%') ? this.$data.promotionMechanism : `${this.$data.promotionMechanism}%`
    } else if (typeof this.$data.promotionMechanism !== 'string' && this.$data.promotionMechanism?.value && this.$data.promotionActuelle.type === 0) {
      this.$data.promotionActuelle.mechanism = this.$data.promotionMechanism.value
    } else if (this.$data.promotionActuelle.type !== 0) {
      this.$data.promotionActuelle.mechanism = this.$data.promotionMechanism
    }
  }

  @Watch('$route.params.id', { immediate: true, deep: true })
  onRouteChanged () {
    this.fetchDatas()
  }
}
